// extracted by mini-css-extract-plugin
export default {"usersPageNames":"user_page_usersPageNames__ZQxQn","usersPage":"user_page_usersPage__e4IN-"};